<template> 
    <form method="POST" :action="route">     
        <input type="hidden" name="_token" :value="token">   
            
                <table class="myfotable">
                    <thead style="background-color: rgba(38, 43, 62, .05)">
                        <tr style="border-right: 1px solid #E9EAF0; border-left: 1px solid #E9EAF0;">
                            <th scope="col" style="width: 32%;">Platforme</th>
                            <th scope="col" style="width: 32%;">Identifiant</th>
                            <th scope="col" style="width: 32%;">Mot de passe</th>
                            <th scope="col" style="width: 4%;"></th>
                        </tr>
                    </thead>
                    <tbody>        
                        <tr v-for="(investment, index) in invs" :key="index" style="border-right: 1px solid #E9EAF0; border-left: 1px solid #E9EAF0;">
                            <input type="hidden"
                                :name="'form[' + index + '][id]'"  
                                :value="investment.id ">
                            <td style="width: 32%;">                          
                                <select                                
                                    class="form-control-2"
                                    style="font-size:11px;"
                                    v-model="investment.platform"
                                    :disabled="investment.id != null">                                               
                                    <option value="" disabled>Nom</option>
                                    <option v-for="platform in plats" :key="platform.id" :value="platform" >{{ platform.name }}</option>   
                                </select>
                                <input type="hidden"
                                    :name="'form[' + index + '][platform_id]'"  
                                    :value="investment.platform.id ">          
                            </td> 
                            <td style="width: 32%;">
                                <input
                                    type="text"
                                    class="form-control"  
                                    placeholder="Votre identifiant"          
                                    :name="'form[' + index + '][username]'"                 
                                    v-model.number="investment.username">
                            </td>
                            <td style="width: 32%;">
                                <input
                                        type="password" 
                                        class="form-control" 
                                        style=""
                                        placeholder="Votre mot de passe"
                                        :name="'form[' + index + '][password]'"                 
                                        v-model.number="investment.password">
                            </td>
                            <td style="width: 4%;">
                                <button
                                    style="font-size:20px!important; text-align:center; vertical-align:middle; color:red;"
                                    v-if="!investment.disabled"
                                    type="button"
                                    class="close"
                                    aria-label="Close"
                                    v-on:click="invs.splice(invs.indexOf(investment), 1)">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                        </td>                  
                        </tr>       
                    </tbody>
                </table>
            
        <div class="m-4 justify-content-center text-center">
            <button type="button" class="btn-myfo-blue" v-on:click="addRaw"><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle mr-2" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/><path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/></svg>Rajouter un compte</button>            
            <button type="submit" class="btn-myfo-blue triggerspinner">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise mr-1" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"/>
                    <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"/>
                </svg>
                Mettre à jour mes positions
            </button>  
        </div>    
    </form>  
</template>

<script>
    export default {
        props: [
            'investments',
            'platforms',
            'token',
            'route',
        ],

        data() {
            return {                         
                form: [],
                invs:[],
                plats: [],
            }           
        },
       
        mounted() { 
            
            this.platforms.forEach(platform =>
            {
                this.plats.push(platform)           
            });
            this.investments.forEach(investment =>
            {
                this.invs.push(
                {
                    id: investment.id,
                    platform: this.plats.find(element => element.id == investment.platform.id),                          
                });              
            });
    
        },
        methods: {  
            addRaw(){
                this.invs.push(
                {        
                    id: null,            
                    platform: this.plats[0],            
                });
            
        }     
    }
}

</script>